import { ElementRef, Injectable, Injector, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { VALIDATION_PATTERNS } from './validation-patterns';
import Swal from 'sweetalert2';
import moment from 'moment';

@Injectable()
export class BaseClass {

  private routerForBaseClass: Router;
  public notAvailable = 'N/A';

  constructor(public injector: Injector) {
    this.routerForBaseClass = injector.get(Router);
  }

  getErrorMessage(formGroup, validation_messages, validation_item): string { 
    let message = '';
    const keys = Object.keys(formGroup.controls);
    const index = keys.indexOf(validation_item);
    if (index !== -1) {
      const control = formGroup.get(keys[index]);
      if (control instanceof FormControl) {
        message = this.getControlErrorMessage(control, validation_messages, validation_item);
      }
    } else {
      for (let i = 0; i < keys.length; i++) {
        const control = formGroup.get(keys[i]);
        if (control instanceof FormGroup) {
          this.getErrorMessage(control, validation_messages, validation_item);
        } else if (control instanceof FormArray) {
          message = this.validateFormArray(control, validation_messages, validation_item);
          break;
        }
      }
    }
    
    return message;
  }
  // to validate form array
  private validateFormArray(formControl: FormArray, validation_messages, validation_item) {
    let message = '';
    for (let i = 0; i < formControl.controls.length; i++) {
      message = this.getErrorMessage(formControl.controls[i], validation_messages, validation_item);
      if (message !== '') {
        break;
      }
    }
    return message;
  }

  getMessageByType(errorType: string, validation_messages, validation_item) {
    const messageObj = validation_messages[validation_item].find(e => e.type === errorType);
    return messageObj ? messageObj.message : null;
  };
  // new
   private getControlErrorMessage(control, validation_messages?: any, validation_item?: any) {
    const controlErrors = control.errors;
    if (!controlErrors) return null; // Early return if there are no errors

    if (controlErrors['pattern']) {
      const pattern = controlErrors['pattern'].requiredPattern;

      switch (pattern) {

        case VALIDATION_PATTERNS.SPACERISTRICT.toString():
          return this.getMessageByType('SPACERISTRICT', validation_messages, validation_item);

        case VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR.toString():
          return this.getMessageByType('NOTALLOW_SPECIAL_CHAR', validation_messages, validation_item);

        case VALIDATION_PATTERNS.ONLYNUMERIC_NOTALLOW.toString():
          return this.getMessageByType('ONLYNUMERIC_NOTALLOW', validation_messages, validation_item);

        case VALIDATION_PATTERNS.EMAIL.toString():
          return this.getMessageByType('EMAIL', validation_messages, validation_item);

        case VALIDATION_PATTERNS.PHONE.toString():
          return this.getMessageByType('PHONE', validation_messages, validation_item);
          
  case VALIDATION_PATTERNS.PHONE_PATTERN.toString():
          return this.getMessageByType('PHONE_PATTERN', validation_messages, validation_item);
        case VALIDATION_PATTERNS.PASSWORD.toString():
          return this.getMessageByType('PASSWORD', validation_messages, validation_item);

        case VALIDATION_PATTERNS.ONLYNUMERIC.toString():
          return this.getMessageByType('ONLYNUMERIC', validation_messages, validation_item);
          
          case VALIDATION_PATTERNS.NOZERO.toString():
            return this.getMessageByType('NOZERO', validation_messages, validation_item);

            case VALIDATION_PATTERNS.SPACERISTRICTDISALLOWSTARTENDSPACE.toString():
            return this.getMessageByType('SPACERISTRICTDISALLOWSTARTENDSPACE', validation_messages, validation_item);

            case VALIDATION_PATTERNS.iChars.toString():
            return this.getMessageByType('iChars', validation_messages, validation_item);

            case VALIDATION_PATTERNS.NUMERICWITHTWODECIMAL.toString():
            return this.getMessageByType('NUMERICWITHTWODECIMAL', validation_messages, validation_item);
            case VALIDATION_PATTERNS.SPACESTRICTFORINITIALVALIDATION.toString():
            return this.getMessageByType('SPACESTRICTFORINITIALVALIDATION', validation_messages, validation_item);
  case VALIDATION_PATTERNS.NOTALLOW_SPECIAL_CHAR_NAME.toString():
            return this.getMessageByType('NOTALLOW_SPECIAL_CHAR_NAME', validation_messages, validation_item);

      }

    }
    if (controlErrors['maxlength']) {
      const { requiredLength, actualLength } = controlErrors['maxlength'];
      if (actualLength > requiredLength) {
        return this.getMessageByType('maxlength', validation_messages, validation_item);
      }
    }

    if (controlErrors['required']) {
      return this.getMessageByType('required', validation_messages, validation_item);
    }
  }


  findInvalidControls(formObject) {
    const invalid = [];
    const controls = formObject.controls;
    for (const name in controls) {
      if (controls[name].invalid || controls[name].hasError('notValid')) {
        invalid.push(name);
      }
    }
  }
  removeValidation(formGroup:FormGroup){
    for (const key in formGroup.controls) {
      formGroup.get(key).clearValidators();
      formGroup.get(key).updateValueAndValidity();
  }
  }

  validateAllFormFields(formGroup: FormGroup | FormArray, el?): void {
    Object.keys(formGroup.controls).map(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup || control instanceof FormArray) {
        this.validateAllFormFields(control); // Recursive call for nested FormGroup/FormArray
      }
    })
    if (el !== undefined) {
      for (const field of Object.keys(formGroup.controls)) {
        const control = formGroup.get(field);
        if (control && control.status === 'INVALID') {
          const invalidControl = el.nativeElement.querySelector(`[formcontrolname="${field}"]`);
          if (invalidControl) {
            // Scroll the invalid control into view
            invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
            // Focus the control after scrolling
            setTimeout(() => {
              // Check if the field is a PrimeNG dropdown or similar component
              const dropdown = 
                invalidControl.querySelector('.p-dropdown-label') || 
                invalidControl.querySelector('.p-dropdown') || 
                invalidControl.querySelector('.p-multiselect-label') || 
                invalidControl.querySelector('.p-multiselect') || 
                invalidControl.querySelector('input');
    
              if (dropdown) {
                setTimeout(() => {
                  dropdown.click();
                  invalidControl.focus();
                  
                }, 100);
              } else {
                invalidControl.focus();
              }              
            }, 300); // Allow time for smooth scrolling animation
            break; // Stop after the first invalid field
          }
        }
      }
    }
    
  }
    scrolldynamicfiled(filed,el){
        const invalidControl =el.nativeElement.querySelector(`[formcontrolname="${filed}"]`);
          if (invalidControl) {
            invalidControl.scrollIntoView({ behavior: 'smooth', block: 'center' });
            setTimeout(() => {
              const dropdown = 
                invalidControl.querySelector('.p-dropdown-label') || 
                invalidControl.querySelector('.p-dropdown') || 
                invalidControl.querySelector('.p-multiselect-label') || 
                invalidControl.querySelector('.p-multiselect') || 
                invalidControl.querySelector('input')|| invalidControl.querySelector('p-calendar');
    
              if (dropdown) {
                setTimeout(() => {
                  dropdown.click();
                  invalidControl.focus();
                  
                }, 100);
              } else {
                invalidControl.focus();
              }              
            }, 300);
          }
  }

  getPlaceholderMessage(validation_messages, validation_item) {
    const messages = validation_messages[validation_item].filter(e => e.type === 'placeholder').map(e => {
      return e.message
    });
    return messages;


  }
  validateMaxLen(validation_messages, validation_item) {      //in audit 
    const messages = validation_messages[validation_item].filter(e => e.type === 'maxlength').map(e => { return e.message });
    return messages[0];

  }



  dynamicformValidation(formGroup: FormGroup, fieldname, patternfor) {
    console.log(fieldname,"name");
    // formGroup.controls()
    
    const newValidators = [];
    for (const key in patternfor) {
      if (key === 'pattern') {
        newValidators.push(Validators.pattern(patternfor[key]));
      } else if (key === 'required' && patternfor[key] === true) {
        newValidators.push(Validators.required);
      } else if (key === 'maxlength' && patternfor[key] !== '') {
        newValidators.push(Validators.maxLength(patternfor[key]));
      } else if (key === 'minlength' && patternfor[key] !== '') {
        newValidators.push(Validators.minLength(patternfor[key]));
      }
    }
    const control = formGroup.get(fieldname);
    if (control) {
      control.addValidators(newValidators.length ? Validators.compose(newValidators) : null);
      control.updateValueAndValidity(); // Refresh validation
    }
  }
// form value changes ditect
isformValueChange(form: any) {
  let changeValues = {};
  Object.keys(form.controls)
      .forEach(key => {
          let currentControl = form.controls[key];
          if (currentControl.dirty) {
              if (currentControl.controls)
                changeValues[key] = this.isformValueChange(currentControl);
              else
              changeValues[key] = currentControl.value;
          }
      });
if(changeValues && Object.keys(changeValues).length > 0){
 return {change:true,value:changeValues}
}else{
return {change:false,value:changeValues};
}

}


closemodal(form:any,ref:any,message){  
     if(this.isformValueChange(form).change){
        Swal.fire({
          title: message,
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: "No",
          denyButtonText: "Yes"
        }).then((result) => {
          if (result.isDenied) {
            ref.close();
  
          }
        });
      }else{
        ref.close();
  
      }

}

convertToDate(dateValue: any) { //convert for path value
  return dateValue && dateValue.trim() ? new Date(dateValue) : null;
}
formatDate(value: any, format: string = 'DD-MMM-YYYY') { // convert for save payload
  if (typeof value === 'string' && value.trim()) {
    return moment(value).format(format);
  } else if (value instanceof Date) {
    return moment(value).format(format);
  } else {
    return '';
  }
}

}
